import { Routes, Route } from 'react-router-dom';
import { ArcheLayout } from '../../../components/ArcheLayout';
import { StorageBrowsePage } from '../../shared/storage';
import { api } from '@/lib/api';
import { queryKeys } from '@/lib/query-keys';
import type { StorageArcheConfig } from '../../shared/storage';

const config: StorageArcheConfig = {
  title: 'DFE Icons',
  requiredRole: 'litcraft_admin',
  accessDeniedMessage: 'You need admin or litcraft_admin permissions to access DFE Icons.',
  queryKeyNamespace: queryKeys.dfeIcons.all,
  api: api.dfeIconsStorage,
  acceptedFileTypes: 'image/*',
};

export function DfeIconsArchePage() {
  return (
    <ArcheLayout>
      <Routes>
        <Route path="/*" element={<StorageBrowsePage config={config} />} />
      </Routes>
    </ArcheLayout>
  );
}
